import useBootstrapData from './useBootstrapData';

export default function useUserDisplayName(): string | undefined {
  const bootstrapData = useBootstrapData();
  return bootstrapData?.user_display_name;
}
